<template>
  <section class="container-full-5">

    <h2 class="secondary-font gap-4 mt-2 mb-4">
      Mon profil
    </h2>

    <!-- Informations personnelles -->
    <div class="s20 widget bg-color-1000 text-white px-7 py-7 rounded-40">
      <div class="flex align-items-center gap-4 mb-4" style="justify-content: space-between; flex-wrap: wrap;">
        <h2 class="secondary-font" style="margin: 0;">
          Informations personnelles
        </h2>
        <router-link to="/front/profil/informations-personnelles" class="btn white2 active">
          <img src="/public/icons/icon-edit.svg" class="btn-icon" alt="" />
          <span>Modifier</span>
        </router-link>
      </div>
      <div class="s4_mobile px-2">
        <img
          :src="profil?.photo_url || profil?.avatar_url || profil?.photo || profil?.avatar || '/public/assets/users/300w/user2.jpg'"
          width="100%"
          class="rounded-100 overflow-hidden item active"
        />
      </div>
      <div class="s6_mobile px-5 mt-5">
        <h2 class="secondary-font mb-4">
          {{ profil?.prenom || '' }} <br/>{{ profil?.nom || '' }}
        </h2>
        <h3 class="secondary-font font-normal mb-3">
          {{ profil?.collectivite_nom || '-' }}
        </h3>
        <template v-if="!isGerant">
          <h6 class="secondary-font font-normal mb-2">
            Ancienneté
          </h6>
          <h6 class="secondary-font mb-4">
            {{ profil?.anciennete || '-' }}
          </h6>
        </template>
      </div>

      <div class="s5_mobile px-3 mt-5">
        <h6 class="secondary-font font-normal mb-2">
          Numéro de téléphone
        </h6>
        <h6 class="secondary-font mb-4">
          {{ maskedPhone }}
        </h6>
        <h6 class="secondary-font font-normal mb-2">
          Adresse e-mail
        </h6>
        <h6 class="secondary-font mb-4">
          {{ maskedEmail }}
        </h6>
      </div>

      <div v-if="!isGerant" class="s5_mobile px-3 mt-5">
        <h6 class="secondary-font font-normal mb-2">
          Salaire
        </h6>
        <h6 class="secondary-font mb-4">
          {{ formatAmount(profil?.salaire || 0) }} F
        </h6>
        <h6 class="secondary-font font-normal mb-2">
          Prélèvement {{ profil?.prelevement_pourcent || 0 }}%
        </h6>
        <h6 class="secondary-font mb-4">
          {{ formatAmount(profil?.prelevement_montant || 0) }} F
        </h6>
        <h6 class="secondary-font font-normal mb-2">
          Date d'engagement
        </h6>
        <h6 class="secondary-font mb-4">
          {{ formatDateFrench(profil?.date_engagement) }}
        </h6>
      </div>
    </div>

    <!-- Souscription -->
    <div v-if="!isGerant" class="widget s20 bg-black text-white p-4 rounded-40 mt-5 px-7 py-7">
      <div class="flex align-items-center gap-4 mb-4">
        <img src="/public/icons/icon-souscription.svg" class="size-base icon-white" alt="" />
        <h4 class="secondary-font">
          Ma Souscription
        </h4>
        <span v-if="souscription?.actif" class="tag-state success ml-4">Active</span>
        <span v-else class="tag-state warning ml-4">Inactive</span>
      </div>
      <h6 class="secondary-font font-normal mb-2">
        Mon revolving
      </h6>
      <h2 class="secondary-font mb-2">
        {{ formatAmount(profil?.revolving || souscription?.revolving || 0) }} F
      </h2>
      <h6 class="secondary-font text-primary-color">
        Valable jusqu'au {{ formatDateFrench(souscription?.date_fin) }}
      </h6>
    </div>

    <div v-if="!isGerant" class="clear-both h-30"></div>

    <!-- Adresses de livraison -->
    <div v-if="!isGerant" class="s12">
      <h2 class="secondary-font mb-3">Adresse de livraison</h2>

      <div
        v-for="adresse in adresses"
        :key="adresse.id"
        class="card-check bg-white-50 widget flex my-2 py-5 px-6"
        :class="{ active: adresse.is_default }"
      >
        <label class="s20" :for="'adresse_' + adresse.id">
          <div class="s1 mt-1">
            <input
              type="radio"
              name="adresse"
              :id="'adresse_' + adresse.id"
              :value="adresse.id"
              :checked="adresse.is_default"
            />
          </div>
          <h5 class="s16 pl-2 secondary-font">
            {{ adresse.libelle }}<br class="mb-2"/>
            <span class="secondary-font text-grey-600">
              {{ adresse.ville }} {{ adresse.commune }} {{ adresse.adresse }}<br/>
              {{ adresse.telephone }}
            </span>
          </h5>
          <div class="s3 text-right">
            <img
              :src="adresse.is_default ? '/public/icons/icon-livraison-domicile.svg' : '/public/icons/icon-livraison-relais.svg'"
              class="size-base"
              alt=""
            />
          </div>
        </label>
      </div>

      <div v-if="adresses.length === 0 && !loading" class="text-grey-600 mb-4">
        Aucune adresse enregistrée
      </div>

      <button class="btn lg stroke w-100 flex-center" @click="showAddAddress = true">
        <span>Ajouter une nouvelle adresse</span>
      </button>
      <div class="clear-both h-20"></div>
    </div>

    <div v-if="!isGerant" class="s1_mobile">&nbsp;</div>

    <!-- Point relais -->
    <div v-if="!isGerant" class="s7_mobile">
      <h2 class="secondary-font gap-4 mb-6">
        Point relais
      </h2>
      <h4 class="secondary-font mb-4 text-grey-700 line-height-2-5">
        Siège de la collectivité<br/>
        {{ profil?.collectivite_nom || '-' }}
      </h4>
    </div>

    <div class="clear-both h-60"></div>

    <!-- Modal ajout adresse -->
    <div v-if="showAddAddress" class="modal-overlay" @click.self="showAddAddress = false">
      <div class="widget rounded-40 px-7 py-7" style="max-width: 500px; width: 90%; margin: auto;">
        <h3 class="secondary-font mb-5">Créer une adresse de livraison</h3>

        <div class="form-field-floating reactive mb-4" :class="{ active: newAddress.libelle }">
          <input v-model="newAddress.libelle" type="text" class="form-field-input" id="addr_libelle" />
          <label for="addr_libelle" class="form-field-label">Nom de l'adresse <b class="color-danger">*</b></label>
        </div>

        <div class="form-field-floating reactive mb-4" :class="{ active: newAddress.ville }">
          <input v-model="newAddress.ville" type="text" class="form-field-input" id="addr_ville" />
          <label for="addr_ville" class="form-field-label">Ville <b class="color-danger">*</b></label>
        </div>

        <div class="form-field-floating reactive mb-4" :class="{ active: newAddress.commune }">
          <input v-model="newAddress.commune" type="text" class="form-field-input" id="addr_commune" />
          <label for="addr_commune" class="form-field-label">Commune <b class="color-danger">*</b></label>
        </div>

        <div class="form-field-floating reactive mb-4" :class="{ active: newAddress.adresse }">
          <input v-model="newAddress.adresse" type="text" class="form-field-input" id="addr_adresse" />
          <label for="addr_adresse" class="form-field-label">Adresse complète <b class="color-danger">*</b></label>
        </div>

        <div class="form-field-floating reactive mb-4" :class="{ active: newAddress.telephone }">
          <input v-model="newAddress.telephone" type="text" class="form-field-input" id="addr_telephone" />
          <label for="addr_telephone" class="form-field-label">Numéro de téléphone <b class="color-danger">*</b></label>
        </div>

        <button
          class="btn lg w-100 flex-center"
          :disabled="savingAddress"
          @click="handleCreateAddress"
        >
          <span>{{ savingAddress ? 'Enregistrement...' : 'Ajouter l\'adresse' }}</span>
        </button>
      </div>
    </div>

  </section>
</template>

<script lang="ts">
import { defineComponent, ref, computed, onMounted } from 'vue'
import profilService from '@/services/profilService'
import authService from '@/services/authService'
import { useProfileStore } from '@/stores/profile.store'
import { useSubscriptionStore } from '@/stores/subscription.store'
import { formatAmount, formatDateFrench, maskPhone, maskEmail } from '@/utils/formatters'
import { showAlert } from '@/utils/swal'

export default defineComponent({
  name: 'MonProfil',
  setup() {
    const profileStore = useProfileStore()
    const subscriptionStore = useSubscriptionStore()
    const loading = ref(true)
    const showAddAddress = ref(false)
    const savingAddress = ref(false)

    const newAddress = ref({
      libelle: '',
      ville: '',
      commune: '',
      adresse: '',
      telephone: ''
    })

    const profil = computed(() => profileStore.profil)
    const souscription = computed(() => subscriptionStore.souscription)
    const adresses = computed(() => profileStore.adresses)
    const isGerant = computed(() => {
      const u = authService.getCurrentUser()
      return !!u?.is_gerant
    })

    // Données masquées
    const maskedPhone = computed(() => maskPhone(profil.value?.telephone))
    const maskedEmail = computed(() => maskEmail(profil.value?.email))

    async function loadProfil() {
      loading.value = true
      try {
        const tasks: Promise<any>[] = [profileStore.fetchProfil()]
        if (!isGerant.value) {
          tasks.push(subscriptionStore.fetchSouscription())
          tasks.push(profileStore.fetchAdresses())
        }
        await Promise.all(tasks)
      } catch (e) {
        // Fallback sur les données localStorage si le store est vide
        if (!profil.value) {
          const user = authService.getCurrentUser()
          if (user) {
            profileStore.profil = {
              id: user.id,
              nom: user.nom,
              prenom: user.prenom,
              telephone: user.telephone,
              email: user.email,
              fonction: user.fonction || '',
              salaire: user.salaire || 0,
              photo: user.photo || null,
              photo_url: user.photo_url || null,
              avatar: user.avatar || null,
              avatar_url: user.avatar_url || null,
              age: null,
              anciennete: null,
              date_naissance: user.dateNaissance || null,
              date_engagement: user.dateEngagement || null,
              quotite_cessible_pourcent: user.quotiteCessiblePourcent || 0,
              quotite_cessible_montant: user.quotiteCessibleMontant || 0,
              collectivite_id: user.collectivite?.id || null,
              collectivite_nom: user.collectivite?.nom || null,
              souscription: null,
              prelevement_pourcent: null,
              prelevement_montant: null,
              pouvoir_achat: null,
              revolving: null,
              utilisation_total: null,
              salaire_net: null
            }
          }
        }
      } finally {
        loading.value = false
      }
    }

    async function handleCreateAddress() {
      if (!newAddress.value.libelle || !newAddress.value.ville || !newAddress.value.commune || !newAddress.value.adresse || !newAddress.value.telephone) {
        showAlert.error('Veuillez remplir tous les champs obligatoires')
        return
      }

      savingAddress.value = true
      try {
        const user = authService.getCurrentUser()
        const res = await profilService.createAdresse({
          ...newAddress.value,
          user_id: user?.id || 0
        })
        if (res.data) {
          profileStore.invalidateAdresses()
          await profileStore.fetchAdresses(true)
          showAddAddress.value = false
          newAddress.value = { libelle: '', ville: '', commune: '', adresse: '', telephone: '' }
          showAlert.success('Adresse ajoutée avec succès')
        } else {
          showAlert.error(res.message || 'Erreur lors de la création')
        }
      } catch (e) {
        showAlert.error('Erreur lors de la création de l\'adresse')
      } finally {
        savingAddress.value = false
      }
    }

    onMounted(() => {
      loadProfil()
    })

    return {
      loading,
      profil,
      souscription,
      adresses,
      isGerant,
      maskedPhone,
      maskedEmail,
      showAddAddress,
      savingAddress,
      newAddress,
      formatAmount,
      formatDateFrench,
      handleCreateAddress
    }
  }
})
</script>

<style scoped>
.profile-avatar-placeholder {
  width: 100%;
  aspect-ratio: 1;
  background: rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
